import logo from "./logo.svg";
import "./App.css";
import AllRoutes from "./AllRoutes/AllRoutes";
import Home from "./AllRoutes/Home";

function App() {
  return (
    <div className="App">
      <AllRoutes />
      {/* <Home /> */}
    </div>
  );
}

export default App;
